const prod = {
    url: {
        API_URL: process.env.REACT_APP_API_URL,
    },
    walletConnect: {
        1: 'https://eth-mainnet.g.alchemy.com/v2/RKTPKDWgE7CtF6eraW52hUMWcdb2pr0X',
    },
    creditsPlans: [
        {
            arcadeCredits: 10,
            tamaRequired: 100,
            isActive: true,
        },
        {
            arcadeCredits: 25,
            tamaRequired: 250,
            isActive: false,
        },
        {
            arcadeCredits: 50,
            tamaRequired: 500,
            isActive: true,
        },
        {
            arcadeCredits: 100,
            tamaRequired: 900,
            isActive: false,
        },
        {
            arcadeCredits: 500,
            tamaRequired: 4000,
            isActive: true,
        },
        {
            arcadeCredits: 1000,
            tamaRequired: 7500,
            isActive: false,
        },
        {
            arcadeCredits: 5000,
            tamaRequired: 30000,
            isActive: true,
        },
        {
            arcadeCredits: 10000,
            tamaRequired: 50000,
            isActive: false,
        },
    ],
    s3BaseUrl:"https://d3fem79psw5246.cloudfront.net/",
    bugsnagUrl : process.env.REACT_AAP_BUG_KEY
};

const dev = {
    url: {
        API_URL: process.env.REACT_APP_API_URL,
    },
    walletConnect: {
        5: 'https://eth-goerli.g.alchemy.com/v2/Riq5Qxh8ze4FiNAjF5FkjWqePFpDkDMK',
    },
    creditsPlans: [
        {
            arcadeCredits: 10,
            tamaRequired: 100,
            isActive: true,
        },
        {
            arcadeCredits: 25,
            tamaRequired: 250,
            isActive: false,
        },
        {
            arcadeCredits: 50,
            tamaRequired: 500,
            isActive: true,
        },
        {
            arcadeCredits: 100,
            tamaRequired: 900,
            isActive: false,
        },
        {
            arcadeCredits: 500,
            tamaRequired: 4000,
            isActive: true,
        },
        {
            arcadeCredits: 1000,
            tamaRequired: 7500,
            isActive: false,
        },
        {
            arcadeCredits: 5000,
            tamaRequired: 30000,
            isActive: true,
        },
        {
            arcadeCredits: 10000,
            tamaRequired: 50000,
            isActive: false,
        },
    ],
    s3BaseUrl:"https://d3fem79psw5246.cloudfront.net/",
    bugsnagUrl : process.env.REACT_AAP_BUG_KEY
};
export const config = process.env.REACT_APP_NODE_ENV === 'production' ? prod : dev;
